import React from 'react';
import { motion } from 'framer-motion';
import './Footer.css';

const Footer = () => {
  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  const openWaitlist = () => {
    document.getElementById('waitlistModal').style.display = 'block';
    document.body.style.overflow = 'hidden';
  };

  return (
    <footer className="footer">
      <div className="container">
        <motion.div
          className="footer-cta"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <div className="footer-cta__copy">
            <span className="footer-cta__eyebrow">Future of accessible real estate</span>
            <h2>Build wealth through shared ownership</h2>
            <p>
              GusHome turns rent into equity. Be the first to access new listings, investor education,
              and limited beta releases.
            </p>
          </div>
          <div className="footer-cta__actions">
            <button className="cta-button cta-button--primary" onClick={openWaitlist}>
              Join the Waitlist
            </button>
            <button className="cta-button cta-button--ghost" onClick={() => scrollToSection('pricing')}>
              View Pricing
            </button>
          </div>
        </motion.div>

        <motion.div
          className="footer-simple"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          viewport={{ once: true }}
        >
          <p>Questions about co-owning with GusHome? We’re here to help.</p>
          <button type="button" onClick={() => scrollToSection('how-it-works')}>
            Learn how it works
          </button>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;